export default __webpack_public_path__ + "static/media/warning-2.83e952f7.svg";